import React from "react";
import { Typography } from "antd";

const { Title } = Typography;

const AlertsNotifications: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <Title level={2}>Coming Soon</Title>
    </div>
  );
};

export default AlertsNotifications;
